import React from "react"
import Drawer from "./Drawer"
import { toggleDrawer } from "../store/action"
import { connect } from "react-redux"
import Menu from "@material-ui/icons/Menu"
import { event } from "./reactGA"
import { withStyles } from "@material-ui/core/styles"

const styles = (theme) => ({
  drawer: {
    width: 400,
    flexShrink: 0,
  },
  drawerPaper: {
    width: 700,
    position: "relative",
    background: "transparent",
  },
  modal: {
    backgroundColor: "rgba(0, 0, 0, 0.9)",
  },
})

const MenuBar = ({ drawerOpen, toggleDrawer, classes, children = null }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Drawer
        open={drawerOpen}
        onChange={(open) => {
          toggleDrawer({ drawerOpen: false })
          event({
            category: "Home Page",
            action: "Menu Close",
          })
        }}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        {children}
      </Drawer>
      <div
        className='pointer'
        style={{ padding: "0px 18px", color: "#ffffff", marginTop: 5 }}
        onClick={(_) => {
          toggleDrawer({ drawerOpen: true })
          event({
            category: "Home Page",
            action: "Menu Open",
          })
        }}
      >
        <Menu />
      </div>
    </div>
  )
}

export default withStyles(styles)(
  connect(
    (state, ownProps) => {
      let mapStateToProps = {}
      if (state.component) {
        mapStateToProps.drawerOpen = state.component.drawerOpen
      }
      return mapStateToProps
    },
    {
      toggleDrawer,
    }
  )(MenuBar)
)



// WEBPACK FOOTER //
// ./src/components/Menu.js